module.exports = __webpack_public_path__ + "static/media/managingtime_sl_results.38675099.png";